export const initKey = "test33_HypoactiveHeidi"
export const initModel = "Seal_Animation"
export const initVar = "Sleep_Code"
export const playing = true
export const speed = 10
export const speedOptions = [1, 10, 50, 100, 1000]
export const initIdx = 0
export const initCmap = {
    'Active Waking': [221, 241, 246],
    'Quiet Waking': [221, 241, 246],
    'HV Slow Wave Sleep': [131, 183, 200],
    'LV Slow Wave Sleep': [160, 247, 224],
    'Certain REM Sleep': [255, 240, 145],
    "Putative REM Sleep": [255, 240, 145]
}